import type { MainPanelConfig, TabOption } from "@/panels/modules/panels/store/panels.store.types";

export const defaultMainPanelConfig: MainPanelConfig = Object.freeze({
    selectedTab: "a",
    a: {
        headerTitle: "Tab A",
        tabTitle: "Tab A",
        isMinimized: false,
        isClosed: true,
        showHeader: true,
    },
    b: {
        headerTitle: "Tab B",
        tabTitle: "Tab B",
        isMinimized: false,
        isClosed: true,
        showHeader: true,
    },
});

export function isTabOption(value: string | null): value is TabOption {
    return value === "a" || value === "b";
}

export const getOtherTab = (tab: TabOption): TabOption => {
    return tab === "a" ? "b" : "a";
};
